import { memo } from 'react'
import { cn } from '@/lib/utils'

/** AI Elements Shimmer 的纯 CSS 版本(原实现依赖 motion,此处用 index.css 的 .ai-shimmer 动画)。 */
export interface ShimmerProps {
  children: string
  className?: string
  /** 动画时长(秒) */
  duration?: number
  /** 高亮带宽度系数,对应原实现的 spread */
  spread?: number
}

export const Shimmer = memo(({ children, className, duration = 2, spread = 2 }: ShimmerProps) => (
  <span
    className={cn('ai-shimmer inline-block', className)}
    style={{
      ['--spread' as string]: `${children.length * spread}px`,
      animationDuration: `${duration}s`,
    }}
  >
    {children}
  </span>
))

Shimmer.displayName = 'Shimmer'
